import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Summary from "../components/Summary";
import {
    getBooking,
    getIsSaveDraftSuccessful, getIsSubmitting,
    isEditing, isUpdating,
} from "../../../data/booking/selectors/booking";
import {
    showAddService,
    addServiceData,
    changeComment,
    submit,
} from "../../../data/booking/actions/booking";
import * as serviceTypes from "../../../data/booking/constants/service_types";
import {isValid, isUpdateValid} from "../../../data/booking/validators/submit";
import {isEmpty} from "lodash";
import {getLastHike} from "../../../data/booking/selectors/hike";
import withRouter from "../../../data/shared/withRouter";
import {Navigate} from "react-router-dom";
import {generate} from "../../../routing/routes";

class SummaryContainer extends Component {
    static propTypes = {
        booking: PropTypes.object,
        showAddService: PropTypes.func,
        addServiceData: PropTypes.func,
        changeComment: PropTypes.func,
    };

    handleChangeComment(e) {
        this.props.changeComment(e.target.value);
    }

    handleSubmit() {
        this.props.submit();
    }

    handleBack() {
        this.props.router.navigate(generate('account_dashboard'))
    }

    render() {
        const { booking, anonymous, isEditing, isUpdating, isUpdateValid, draftSaved, loadingSteps, isValid, hike, isSubmitting } =
            this.props;

        const services = serviceTypes.getServiceList().filter((service)=> {
                return hike&&(isEmpty(hike.services) || hike.services.includes(service.type))
            })
        return (
            <Summary
                serviceList={services}
                readOnly={draftSaved || loadingSteps.length > 0}
                data={booking}
                onChangeComment={::this.handleChangeComment}
                anonymous={anonymous}
                isEditing={isEditing}
                isUpdateValid={isUpdateValid}
                isValid={isValid}
                isSubmitting={isSubmitting}
                isUpdating={isUpdating}
                onSubmit={::this.handleSubmit}
                onBack={::this.handleBack}
            />
        );
    }
}

export default connect(
    (state) => ({
        booking: getBooking(state.booking),
        anonymous: null == state.account.userSession.data,
        isEditing: isEditing(state),
        isUpdating: isUpdating(state),
        draftSaved: getIsSaveDraftSuccessful(state.booking),
        loadingSteps: state.booking.map.loadingSteps,
        isValid: isValid(state.booking.booking.entities),
        isUpdateValid: isUpdating(state) ? isUpdateValid(state.booking.booking.entities) : true,
        hike: getLastHike(state.booking),
        isSubmitting: getIsSubmitting(state.booking)
    }),
    (dispatch) =>
        bindActionCreators(
            { showAddService, changeComment, submit, addServiceData },
            dispatch
        )
)(withRouter(SummaryContainer));
